import { GetRegistrationModel } from "@factory/model/query-model-registration";

export const calendarUtils = {
  combineDateTime: (date: string, time: string): string => {
    if (!date || !time) return "";
    const dateOnly = new Date(date).toISOString().split("T")[0];
    const combinedDateTime = new Date(`${dateOnly}T${time}:00`);
    return combinedDateTime.toISOString();
  },

  addHourToTime: (date: string, time: string): string => {
    if (!date || !time) return "";
    const dateOnly = new Date(date).toISOString().split("T")[0];
    const dateTime = new Date(`${dateOnly}T${time}:00`);
    dateTime.setHours(dateTime.getHours() + 1);
    return dateTime.toISOString();
  },

  formatClientName: (registration: GetRegistrationModel): string => {
    const parts = [
      registration.first_name,
      registration.middle_name,
      registration.last_name,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(" ") : "Unnamed Client";
  },

  formatEventTitle: (registration: GetRegistrationModel): string => {
    const clientName = calendarUtils.formatClientName(registration);
    const serviceName = registration.service_name || "Service";
    return `${clientName} - ${serviceName}`;
  },

  getStatusColor: (status: string): string => {
    const statusColors = {
      PENDING: "bg-blue-500",
      APPROVE: "bg-green-500",
      DECLINE: "bg-red-500",
    };
    return statusColors[status as keyof typeof statusColors] || "bg-gray-500";
  },

  getStatusBadgeClass: (status: string): string => {
    const statusClasses = {
      PENDING: "bg-blue-100 text-blue-800",
      APPROVE: "bg-green-100 text-green-800",
      DECLINE: "bg-red-100 text-red-800",
    };
    return (
      statusClasses[status as keyof typeof statusClasses] ||
      "bg-gray-100 text-gray-800"
    );
  },
};
